import React, { useEffect, useState } from 'react'
import './Home.css'
import Table from '../Components/Table'

const COT = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const apikey = process.env.REACT_APP_API_KEY;
  const currentDate = new Date().toLocaleDateString('en-CA');
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://financialmodelingprep.com/api/v4/commitment_of_traders_report?from=2020-09-12&to=${currentDate}&apikey=${apikey}`
        );
        const jsonData = await response.json();
        setData(jsonData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const dataBySector = data.reduce((acc, curr) => {
    const sector = curr.sector;
    if (sector !== "0") {
      if (!acc[sector]) {
        acc[sector] = [];
      }
      acc[sector].push(curr);
    }
    return acc;
  }, {});

  return (
    <div className='home pb-5'>
      <div className="p-sm-5 p-4 mt-5">
        <h1 className='text-center'>COT Reports with Interactive Charts</h1>
        <p className=''>The Commitments of Traders (COT) reports are provided by the Commodity Futures Trading Commission (CFTC). COT reports provide a breakdown of each Tuesday’s open interest for markets in which 20 or more traders hold positions equal to or above the reporting levels established by the CFTC. <br />
          COT reports are used by many speculative traders to help making decisions on whether to take a long or short position. <br />
          However, the original COT reports are text based and the CFTC does not provide any data analytics tools.
          To help you analyze important trends and movements using the Commitment of Traders reports, Tradingster.com provides up-to-date COT reports (including COT reports' historical data) and free COT charts.</p>
      </div>
      <div className="cottables p-4 p-sm-5">
        {isLoading ? (
          <div><img src="./loading1.gif" alt="Loading..." /></div>
        ) : (
          <div className="tables">
            {Object.entries(dataBySector).map(([sector, sectorData]) => (
              <Table key={sector} data={sectorData} sector={sector} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default COT